/**
 * Configuration axios avec gestion des erreurs 403 et retry
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Créer une instance axios configurée
const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Compteur de retry par URL
const retryCount = new Map();
const MAX_RETRIES = 2;

// Intercepteur de réponse - gérer les erreurs 403 et retry
api.interceptors.response.use(
  (response) => {
    const url = response.config.url;
    if (url) retryCount.delete(url);
    return response;
  },
  async (error) => {
    const config = error.config;
    const url = config?.url || '';
    
    if (error.response?.status === 403) {
      const currentRetries = retryCount.get(url) || 0;
      
      if (currentRetries < MAX_RETRIES) {
        retryCount.set(url, currentRetries + 1);
        await new Promise(resolve => setTimeout(resolve, 500 * (currentRetries + 1)));
        return api.request(config);
      }
      console.warn(`API 403 after ${MAX_RETRIES} retries:`, url);
    }
    
    return Promise.reject(error);
  }
);

export default api;
export { api, API_URL };
